<template>
  <div class="c-plan g-container">
    <!-- 导航 -->
    <Breadcrumb style="margin-bottom: 12px">
      <BreadcrumbItem :to="{ name: 'plan', query: { id: plan.campaign_id, t: 'edit' } }">
        <Icon type="ios-home-outline"></Icon> 设置推广计划
      </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="logo-buffer"></Icon> 设置计划 </BreadcrumbItem>
    </Breadcrumb>

    <moduler v-for="item in subModules" :media="media" :key="item.id" :name="item.href" :title="item.name">
      <!-- 基础信息 -->
      <template v-if="item.href === 'plan_basic'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">推广计划</span>
          </Col>
          <Col span="12" style="position: relative">
            <span class="item-field">{{ plan.campaign_name }}</span>
            <div v-if="plan.campaign_ids.length > 1" class="c-group-desc item-field">（共{{ plan.campaign_ids.length }}条推广计划）</div>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">计划名称</span>
          </Col>
          <Col span="18">
            <input-len
              ref="planinput"
              v-model="plan.plan_name"
              placeholder="最大80个字符，1个中文等于2个字符"
              width="480"
              :max="80"
              @on-focus="focusPlan"
              @on-blur="blurPlan"
              :disabled="editState"
            />
            <span style="margin-left: 12px" v-if="check">
              <Icon type="ios-loading" color="#5cadff" size="18" v-if="check === 'loading'" />
              <Icon type="md-checkmark" color="#19be6b" size="18" v-if="check === 'success'" />
              <Icon type="md-close" color="#ed4014" size="18" v-if="check === 'error'" />
              <span v-if="check === 'success'">标题可用</span>
              <span v-if="check === 'error'">此标题已被占用，请换一个！</span>
            </span>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">游戏平台</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.ch_platform_id" @on-change="platformChange" type="button">
              <Radio :label="1" :disabled="editState">Android</Radio>
              <Radio :label="2" :disabled="editState">iOS</Radio>
              <Radio :label="3" :disabled="editState">微信小程序</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">投放游戏</span>
          </Col>
          <Col span="12">
            <auto-complete
              :data="platformGameData"
              v-model="plan.game_id"
              placeholder="请选择推广游戏"
              :width="358"
              :disabled="editState"
              @on-select="handleGame"
            ></auto-complete>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">是否代投</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.agent" type="button" @on-change="changeAgent">
              <Radio label="NOAGENT" :disabled="editState">非代投</Radio>
              <Radio label="AGENT" :disabled="editState">代投</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row v-if="plan.agent === 'AGENT'" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">代投账号</span>
          </Col>
          <Col span="12">
            <auto-complete
              :data="agentData"
              v-model="plan.proxy_account_id"
              placeholder="请选择代投账号"
              :disabled="editState"
              @on-select="handleAgent"
            ></auto-complete>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放方式</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.landing_type" type="button">
              <Radio label="APP" :disabled="editState">APP应用</Radio>
              <Radio label="LINK" :disabled="editState">落地页</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <!-- <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">计划管家</span>
          </Col>
          <Col span="12">
            <select-butler :data="plan.monitorPlan" @on-clear="plan.monitorPlan = []" @on-select="appendButler" :disabled="editState" />
          </Col>
        </Row> -->

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">回调开关</span>
          </Col>
          <Col span="12" class="col-flex">
            <i-Switch v-model="plan.callbackSwitch" :disabled="editState || !isAndroid" :true-value="1" :false-value="0" />
            <span v-if="!isAndroid" style="color: #ff0000; margin-left: 1em">iOS请务必选择需要的回调类型</span>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="plan.callbackSwitch">
          <Col span="3" class="col-item">
            <span class="item-field">回调类型</span>
          </Col>
          <Col span="12" class="col-flex">
            <CheckboxGroup v-model="plan.callbackSettings">
              <Checkbox label="callbackTypeActive" disabled>激活</Checkbox>
              <Checkbox label="callbackTypeRegist" disabled>注册</Checkbox>
              <Checkbox label="callbackTypeRecharge" disabled>付费</Checkbox>
              <Checkbox label="callbackTypeMoney" disabled>订单金额</Checkbox>
            </CheckboxGroup>
          </Col>
        </Row>

        <!-- batch -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">批量建立</span>
          </Col>
          <Col span="12" class="col-flex">
            <i-switch v-model="batch" :disabled="editState" @on-change="changeBatch" />
          </Col>
        </Row>
        <Row v-if="batch" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <Poptip trigger="hover" placement="top-start" width="410" word-wrap content="始末数字最多相差10">
              <Icon type="md-help-circle" size="18" color="#e3e3e3" />
            </Poptip>
            <span class="item-field">数量</span>
          </Col>
          <Col span="12">
            <Input
              v-model="plan.bitch_add_begin"
              placeholder="起始数"
              style="width: 60px"
              @on-blur="inputTrim('bitch_add_begin', plan.bitch_add_begin)"
            />
            <span>&nbsp; ~ &nbsp;</span>
            <Input
              v-model="plan.bitch_add_end"
              placeholder="结束数"
              style="width: 60px"
              @on-blur="inputTrim('bitch_add_end', plan.bitch_add_end)"
            />
          </Col>
        </Row>
      </template>
      <template v-if="item.href === 'quick_search'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <Tooltip placement="top" max-width="300">
              <span class="item-field row-item-must"> 搜索快投 <i class="el-icon-info"></i></span>

              <div slot="content">
                <p>快速投放到搜索流量，并可以主动添加关键词，设置人群探索</p>
              </div>
            </Tooltip>
          </Col>
          <Col span="12">
            <i-switch style="margin-top: 5px" :true-value="1" :false-value="0" v-model="plan.quick_search"></i-switch>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="plan.quick_search">
          <Col span="3" class="col-item">
            <Tooltip placement="top" max-width="300">
              <span class="item-field row-item-must"> 搜索人群探索 <i class="el-icon-info"></i></span>

              <div slot="content">
                <p>系统将基于用户搜索行为探索定向人群以外的更多优质人群</p>
              </div>
            </Tooltip>
          </Col>
          <Col span="12">
            <i-switch style="margin-top: 5px" :true-value="1" :false-value="0" v-model="plan.target_explore"></i-switch>
          </Col>
        </Row>
      </template>

      <!-- 投放目标 -->
      <template v-if="item.href === 'plan_target'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">计划投放位置</span>
          </Col>
          <Col span="12">
            <Mixcheck v-model="plan.scene_id">
              <radio-item :label="1" :disabled="editState">优选投放位</radio-item>
              <!-- <check-item :label="7" :disabled="editState">按场景-信息流广告</check-item> -->
              <check-item :label="6" :disabled="editState">按场景-上下滑大屏投放</check-item>
              <check-item :label="10" :disabled="editState">按场景-快手联盟优选投放</check-item>
              <check-item :label="24" :disabled="editState">按场景-激励视频投放</check-item>
              <radio-item :label="5" :disabled="editState">快手投放联盟</radio-item>
            </Mixcheck>
          </Col>
        </Row>
        <template v-if="isLink">
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">投放类型</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.promoted_type" type="button">
                <Radio :label="0" :disabled="editState">落地页</Radio>
                <Radio :label="1" :disabled="editState || isAndroid || true">预约投放</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <template v-if="plan.promoted_type === 1">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">预约落地页</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="plan.site_type" type="button">
                  <Radio :label="1" :disabled="editState">IOS预约</Radio>
                  <Radio :label="2" :disabled="editState">安卓预约</Radio>
                </RadioGroup>
              </Col>
            </Row>

            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field"></span>
              </Col>
              <Col span="12">
                <Select v-model="plan.site_id" disabled style="width: 220px" placeholder="请选择预约落地页">
                  <Option v-for="item in landPageList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </Col>
            </Row>
          </template>
          <template v-if="plan.promoted_type === 0">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field row-item-must">推广落地页</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="page_type_custom" type="button">
                  <Radio :label="1" :disabled="editState">快手建站落地页</Radio>
                  <Radio :label="2" :disabled="editState">平头哥落地页</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="page_type_custom === 1">
              <Col span="3" class="col-item">
                <span class="item-field"></span>
              </Col>
              <Col span="12">
                <Select v-model="plan.url" placeholder="请选择落地页" :disabled="editState" style="width: 520px">
                  <Option v-for="page in magneticPageData" :key="page.id" :value="page.id" :label="page.name" />
                </Select>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="page_type_custom === 2">
              <Col span="3" class="col-item">
                <span class="item-field"></span>
              </Col>
              <Col span="12">
                <Input v-model="plan.page_addr" disabled style="width: 520px" />
              </Col>
            </Row>
          </template>
        </template>

        <Row class="row-item" :gutter="12" v-if="isAndroid && !isLink">
          <Col span="3" class="col-item">
            <span class="item-field">应用类型</span>
          </Col>
          <Col span="12">
            <Select v-if="editState" v-model="plan.app_type" placeholder="请选择应用类型" :disabled="editState" style="width: 358px">
              <Option v-for="app in appAndList" :key="app.app_id" :value="app.app_id" :label="app.app_version" />
            </Select>
            <Select v-else v-model="plan.app_type" placeholder="请选择应用类型" style="width: 398px">
              <Option value="android">Android应用下载</Option>
            </Select>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="isAndroid && !editState">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">应用名称</span>
          </Col>
          <Col span="12">
            <input-len
              v-model="plan.app_name"
              placeholder="最大100个字符，1个中文等于2个字符"
              width="398"
              :max="100"
              :disabled="editState"
            />
            <p style="color: #ff0000; margin-bottom: 0; margin-top: 1em">
              注意：该处的名字对应的是媒体后台应用名称，有多余的文字请记得手动删除掉
            </p>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="isAndroid && !editState">
          <Col span="3" class="col-item">
            <span class="item-field">应用包名</span>
          </Col>
          <Col span="12">
            <Input v-model="plan.package" placeholder="应用包名根据选择游戏自动获取" style="width: 398px" disabled />
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="isAndroid && !editState">
          <Col span="3" class="col-item">
            <span class="item-field">应用图标</span>
          </Col>
          <Col span="12">
            <img v-if="plan.app_icon" :src="plan.app_icon" width="64px" height="64px" />
            <div v-else style="background-color: #ccc; border-radius: 4px; width: 64px; height: 64px"></div>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-if="isAndroid && !editState">
          <Col span="3" class="col-item">
            <span class="item-field">是否接入快手SDK</span>
          </Col>
          <Col span="12" class="col-flex">
            <i-Switch v-model="plan.use_sdk" :disabled="editState" :true-value="1" :false-value="0" />
            <span v-if="plan.use_sdk === 1" style="color: #ff0000; margin-left: 1em">
              注意：接入了快手sdk的请主要开启此开关，没有接入sdk请关闭开关
            </span>
          </Col>
        </Row>

        <!-- iOS -->
        <Row class="row-item" :gutter="12" v-if="!isAndroid && !isLink">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">选择已有应用</span>
          </Col>
          <Col span="12">
            <Select v-model="plan.app_id" placeholder="请选择应用" :disabled="editState" @on-change="changeiOSApp" style="width: 358px">
              <Option v-for="app in appiOSList" :key="app.app_id" :value="app.app_id" :label="app.real_app_name" />
            </Select>
          </Col>
        </Row>
      </template>

      <!-- 用户定向 -->
      <template v-if="item.href === 'plan_client'">
        <!-- 定向方式 -->
        <Row class="row-item" :gutter="12" v-if="!isUseAdUnion">
          <Col span="3" class="col-item">
            <span class="item-field">定向方式</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.intelli_extend_option" type="button">
              <Radio :label="0">自定义定向</Radio>
              <Radio :label="1">智能定向</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <!-- 地域 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">地域</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="district" type="button" @on-change="radioChange('cityData')">
              <Radio label="NONE">不限</Radio>
              <Radio label="CITY">按省市</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-show="district === 'CITY'">
          <Col span="3">&nbsp;</Col>
          <Col span="14">
            <selecter
              v-model="mult_city"
              :data="cityData"
              :title="['省份', '城市']"
              @on-select="selectAll"
              @on-delete="delTag"
              @on-clear="clearTag"
            />
          </Col>
        </Row>

        <!-- 性别 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">性别</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.gender" type="button">
              <Radio :label="0">不限</Radio>
              <Radio :label="2">男</Radio>
              <Radio :label="1">女</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <!-- 年龄 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">年龄</span>
          </Col>
          <Col span="18">
            <RadioGroup v-model="ageMode" type="button">
              <Radio label="NONE">不限</Radio>
              <Radio label="CUSTOM">自定义年龄</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="ageMode === 'CUSTOM'">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="18">
            <Slider v-model="plan.age" :marks="marks" :step="1" :min="18" :max="75" style="width: 804px" range />
          </Col>
        </Row>

        <!-- 人群包 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">人群包</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="audienceMode" type="button" @on-change="changeRetarget">
              <Radio label="NONE">不限</Radio>
              <Radio label="AUDIENCE">定向或排除人群</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="audienceMode === 'AUDIENCE'">
          <Col span="3">&nbsp;</Col>
          <Col span="17">
            <retarget
              title="选定人群"
              :data="audienceData"
              :payTypeBag="payTypeBag"
              :auto="Boolean(plan.intelli_extend_option)"
              :currenTab="Boolean(plan.intelli_extend_option) ? 'exclude' : 'include'"
              @on-clear="clearRetarget"
              @on-delete="delRetarget"
            />
          </Col>
        </Row>

        <template v-if="!plan.intelli_extend_option">
          <!-- 行为兴趣定向-->
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">行为意向定向</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.behavior_type" type="button" @on-change="resetInterestAction">
                <Radio :label="0">不限</Radio>
                <Radio :label="1">自定义</Radio>
                <!-- <Radio :label="2" :disabled="isUseAdUnion">系统优选</Radio> -->
              </RadioGroup>
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="plan.behavior_type === 1">
            <Col span="3" class="col-item">
              <span class="item-field">行为</span>
            </Col>
            <Col span="15">
              <!-- 新版 -->
              <action-interest
                v-model="plan.action_tags"
                :action-scene="plan.action_scene"
                :action-days="plan.action_days"
                :strength="plan.action_intensity"
                :max="100"
                :accounts="accounts"
                action
                @on-days="setDays"
                @on-scene="setScene"
                @on-intensity="setIntensity('action_intensity', $event)"
              />
            </Col>
          </Row>
          <Row class="row-item" :gutter="12" v-if="plan.behavior_type === 1">
            <Col span="3" class="col-item">
              <span class="item-field">意向</span>
            </Col>
            <Col span="15">
              <!-- 新版 -->
              <action-interest
                v-model="plan.word_tags"
                :strength="plan.interest_intensity"
                :accounts="accounts"
                :max="100"
                @on-intensity="setIntensity('interest_intensity', $event)"
              />
            </Col>
          </Row>
        </template>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">操作系统版本</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.platform_os" type="button">
              <Radio :label="0" disabled>不限</Radio>
              <Radio :label="1" disabled>安卓</Radio>
              <Radio :label="2" disabled>iOS</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <!-- 安卓版本 -->
        <Row class="row-item" :gutter="12" v-if="plan.platform_os === 1">
          <Col span="3" class="col-item">
            <span class="item-field">安卓版本</span>
          </Col>
          <Col span="12">
            <version v-model="plan.android_osv" :data="androidVersion" title="安卓版本" />
          </Col>
        </Row>

        <!-- iOS版本 -->
        <Row class="row-item" :gutter="12" v-if="plan.platform_os === 2">
          <Col span="3" class="col-item">
            <span class="item-field">iOS版本</span>
          </Col>
          <Col span="12">
            <version v-model="plan.ios_osv" :data="iOSVersion" title="iOS版本" />
          </Col>
        </Row>

        <template v-if="!plan.intelli_extend_option">
          <!-- 设备品牌 -->
          <Row class="row-item" :gutter="12" v-if="isAndroid || isMiniGame">
            <Col span="3" class="col-item">
              <span class="item-field">设备品牌</span>
            </Col>
            <Col span="17">
              <Mixcheck v-model="plan.device_brand_ids">
                <radio-item :label="0">不限</radio-item>
                <check-item v-for="item in deviceBrand" :key="item.id" :label="item.value">
                  {{ item.label }}
                </check-item>
              </Mixcheck>
            </Col>
          </Row>

          <!-- 设备价格 -->
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">设备价格</span>
            </Col>
            <Col span="18">
              <Mixcheck v-model="plan.device_price">
                <radio-item :label="0">不限</radio-item>
                <check-item v-for="item in devicePrice" :key="item.id" :label="item.value">
                  {{ item.label }}
                </check-item>
              </Mixcheck>
            </Col>
          </Row>

          <!-- 网络 -->
          <Row class="row-item" :gutter="12">
            <Col span="3" class="col-item">
              <span class="item-field">网络</span>
            </Col>
            <Col span="12">
              <RadioGroup v-model="plan.network" type="button">
                <Radio :label="0">不限</Radio>
                <Radio :label="1">WIFI</Radio>
                <Radio :label="2">移动网络</Radio>
              </RadioGroup>
            </Col>
          </Row>

          <!-- APP定向 -->
          <template v-if="isAndroid && !isUseAdUnion">
            <Row class="row-item" :gutter="12">
              <Col span="3" class="col-item">
                <span class="item-field">APP定向</span>
              </Col>
              <Col span="12">
                <RadioGroup v-model="app_behavior" type="button" @on-change="changeBehavior">
                  <Radio :label="0">不限</Radio>
                  <Radio :label="1">按APP分类</Radio>
                  <Radio :label="2">按APP名称</Radio>
                </RadioGroup>
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="app_behavior === 1">
              <Col span="3">&nbsp;</Col>
              <Col span="17">
                <selecter
                  v-model="mult_app"
                  :data="appData"
                  :title="['APP分类']"
                  @on-select="selectAll"
                  @on-delete="delTag"
                  @on-clear="clearTag"
                />
              </Col>
            </Row>
            <Row class="row-item" :gutter="12" v-if="app_behavior === 2">
              <Col span="3">&nbsp;</Col>
              <Col span="17">
                <adder
                  v-model="mult_cate"
                  :data="categroyData"
                  :loading="cating"
                  :maxtotal="10"
                  :columns="[
                    { type: 'selection', width: 60, align: 'center' },
                    { key: 'name', title: '名称' }
                  ]"
                  @on-select="selectCategroy"
                  @on-search="getCategroy"
                  @on-delete="delCategroy"
                  @on-clear="clearCategroy"
                  placeholder="请输入APP名称"
                />
              </Col>
            </Row>
          </template>
        </template>

        <!-- 过滤已转化用户 -->
        <Row class="row-item" :gutter="12" v-show="!isUseAdUnion">
          <Col span="3" class="col-item">
            <span class="item-field">过滤已转化用户</span>
          </Col>
          <Col span="17">
            <Mixcheck v-model="plan.filter_converted_level">
              <radio-item v-for="item in filterConvertLevel" :key="item.id" :disabled="isLink && item.label === 'APP'" :label="item.value">
                {{ item.label }}
              </radio-item>
            </Mixcheck>
          </Col>
        </Row>
      </template>

      <!-- 预算与出价 -->
      <template v-if="item.href === 'plan_price'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">计划组预算</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="budget" type="button" @on-change="changeBudget">
              <Radio label="NONE" :disabled="plan.speed === 3">不限</Radio>
              <Radio label="BUDGET" :disabled="bidType === 1">日预算</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row v-if="budget === 'BUDGET'" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">&nbsp;</span>
          </Col>
          <Col span="12">
            <Input
              v-model="plan.day_budget"
              placeholder="每日预算范围 100~100,000,000元"
              style="width: 237px"
              @on-blur="inputTrim('day_budget', plan.day_budget, plan, true)"
            >
              <span slot="append" style="padding: 0 6px"> 元 </span>
            </Input>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放方式</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.speed" type="button">
              <Radio :label="1" disabled>加速投放</Radio>
              <!-- <Radio :label="2">平滑投放</Radio>
              <Radio :label="3" :disabled="isUseAdUnion || noSpeedEdit || bidType === 1">优先低成本</Radio> -->
            </RadioGroup>
          </Col>
        </Row>

        <!-- 投放时间 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放时间</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="dateRange" type="button">
              <Radio label="NONE">从今天起长期投放</Radio>
              <Radio label="RANGE">设置开始和结束日期</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row v-if="dateRange === 'RANGE'" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="12">
            <Row :gutter="12">
              <Col span="24">
                <DatePicker
                  type="date"
                  :value="plan.begin_time"
                  placeholder="请选择开始日期"
                  style="width: 160px"
                  :options="{ disabledDate: startOption }"
                  :disabled="editState"
                  @on-change="changeStartTime"
                ></DatePicker>
                <span class="split-line"> —— </span>
                <DatePicker
                  type="date"
                  :value="plan.end_time"
                  placeholder="请选择结束日期"
                  style="width: 160px"
                  :options="{ disabledDate: endOption }"
                  @on-change="changeEndTime"
                ></DatePicker>
              </Col>
            </Row>
          </Col>
        </Row>

        <!-- 投放时段 -->
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">投放时段</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="timeRange" type="button" @on-change="radioChange('weektimeData')">
              <Radio label="NONE">不限</Radio>
              <Radio label="RANGE">指定时间段</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row v-if="timeRange === 'RANGE'" class="row-item" :gutter="12">
          <Col span="3">&nbsp;</Col>
          <Col span="12">
            <drag-weektime v-model="mult_timeRange" :data="weektimeData" :colspan="1" @on-clear="clearWeektime" />
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">创意展现方式</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.show_mode" type="button">
              <Radio :label="2">智能优选</Radio>
              <Radio :label="1">随机轮播</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">优化目标</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.ocpx_action_type" @on-change="changeConversion" type="button">
              <Radio :label="2" :disabled="editState">行为数</Radio>
              <Radio :label="180" :disabled="editState">激活</Radio>
              <Radio :label="190" :disabled="editState">付费</Radio>
              <Radio :label="739" :disabled="editState">7日付费次数</Radio>
              <Radio :label="191" :disabled="editState">首日ROI</Radio>
              <Radio :label="774" :disabled="editState">7日ROI</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">计费类型</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="plan.bid_type" type="button">
              <Radio :label="10" :disabled="editState">OCPM</Radio>
              <Radio :label="12" :disabled="editState">最大转化</Radio>
            </RadioGroup>
          </Col>
        </Row>

        <Row class="row-item" :gutter="12" v-show="deepConversion && !bidType">
          <Col span="3" class="col-item">
            <span class="item-field">深度转化目标</span>
          </Col>
          <Col span="12">
            <Select v-model="plan.deep_conversion_type" placeholder="请选择深度转化目标" @on-change="changeDeepConver" style="width: 358px">
              <Option :value="0" label="无" :disabled="editState || plan.speed === 3" />
              <Option
                v-for="deep in conversionList"
                :key="deep.id"
                :value="deep.id"
                :label="deep.value"
                :disabled="editState || plan.speed === 3"
              />
            </Select>
          </Col>
        </Row>

        <Row v-if="!isROI && !bidType" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">目标出价</span>
          </Col>
          <Col span="12">
            <Input
              v-model="plan.cpa_bid"
              placeholder="请输入目标出价格"
              style="width: 237px"
              @on-blur="inputTrim('cpa_bid', plan.cpa_bid, plan, true)"
            >
              <span slot="append" style="padding: 0 6px"> 元 </span>
            </Input>
          </Col>
        </Row>

        <Row v-if="conversion" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">深度转化目标出价</span>
          </Col>
          <Col span="12">
            <Input
              v-model="plan.deep_conversion_bid"
              placeholder="出价范围 1~10,000元,须大于目标出价小于组预算"
              style="width: 237px"
              @on-blur="inputTrim('deep_conversion_bid', plan.deep_conversion_bid, plan, true)"
            >
              <span slot="append" style="padding: 0 6px"> 元 </span>
            </Input>
          </Col>
        </Row>

        <Row v-if="(isROI || plan.deep_conversion_type === 92) && !bidType" class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">ROI系数</span>
          </Col>
          <Col span="12">
            <input-number-plus
              v-model="plan.roi_ratio"
              :max="3"
              :min="0.001"
              :step="0.001"
              :precision="3"
              :width="237"
              placeholder="请输入系数，范围: 0.001 ~ 100 "
            />
            <span style="padding: 0 6px"> 元 </span>
          </Col>
        </Row>
      </template>
    </moduler>

    <!-- 批量结果 -->
    <resulter
      v-model="model"
      :show="loading"
      title="结果反馈"
      head="创建结果"
      :columns="resulteColumns"
      :data="resData"
      @on-retry="retry"
      @on-close="close"
      @on-next="jump"
    >
    </resulter>

    <div class="c-plan-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="cannelError"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button type="default" @click="cannel">取消</Button>
          <Button type="primary" v-if="editState" :loading="saving" @click.stop="submit(0)">
            <span v-if="!saving">保存并关闭</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="submit(1)">
            <span v-if="!loading">{{ hasCreative ? '保存并修改创意' : '保存并新建创意' }}</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submitToNext">
            <span v-if="!loading">保存并下一步</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import opts from './plan_opts.js'
export default opts
</script>
<style lang="scss" scoped>
.c-plan-submit {
  padding: 15px;
  min-width: 1130px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 #eff1fa;

  .c-btns-submit {
    text-align: right;

    button {
      margin-left: 8px !important;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}

.c-plan {
  height: inherit;

  .m-bread {
    line-height: 20px;
    margin-bottom: 12px;
  }

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 96px);
  }

  .dynamic-error {
    margin: 0;
  }

  .m-dynamic {
    padding-top: 10px;
    margin: 0;

    li {
      display: inline-block;
      margin-left: 12px;
    }
  }

  .col-flex {
    min-height: 32px;
    display: flex;
    align-items: center;
  }

  ::v-deep .row-item {
    align-items: flex-start;

    span.item-field {
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
